(function($){
    $(function(){
        var $condiQuickSelect = $('.zn-condition-quick-select');
        if ($condiQuickSelect.length) {
            $condiQuickSelect.find('.zn-condition-submit').on('click', function(){
                var $this = $(this),
                    $conditionUrl = $this.closest('.zn-condition-quick-select-form').find('.zn-condition-list').val();

                if($conditionUrl){
                    window.location.href = $conditionUrl;
                }
            });
        }
    });
})($JQ);